import React, { Component } from 'react';
import { formatMoney } from './BreakdownHelpers';
import NotesPopup from '../../NotesPopup/NotesPopupContainer';

export default class NeedsAnalysisView extends Component {
  render() {
    const {
      isAdviserArea,
      annualInsuranceCost,
      annualLTCCost,
      assetsToLiquidate,
      dailyBenefit,
      note,
      onNotesClick,
      clientId,
      goalId,
      subgoalId,
      isCurrentPlan,
    } = this.props;

    return (
      <div className="NewFinancialPlan_Insurance_Breakdown">
        <section>
          <NotesPopup {...this.props} />
          <ul>
            <li className="breakdown-item">
              <span className="breakdown-text">
                <span>Assets to Liquidate</span>
                <span className="pill">{formatMoney(assetsToLiquidate)}</span>
              </span>
            </li>
            <li className="breakdown-item">
              <span className="breakdown-text">
                <span>Annual LTC Cost</span>
                <span className="pill">{formatMoney(annualLTCCost)}</span>
              </span>
            </li>
            <li className="breakdown-item">
              <span className="breakdown-text">
                <span>Daily Benefit</span>
                <span className="pill">{formatMoney(dailyBenefit)}</span>
              </span>
            </li>
            <li className="breakdown-item">
              <span className="breakdown-text">
                <span>Annual Insurance Cost</span>
                <span className="pill">{formatMoney(annualInsuranceCost)}</span>
              </span>
            </li>
          </ul>
          <div className="notes">
            <header>
              <span className="recommendations">Recommendation</span>
              {isAdviserArea && !isCurrentPlan && (
                <strong>
                  <a onClick={onNotesClick(clientId, goalId, subgoalId, note.Description)}>
                    <i className="far fa-edit" /> Edit
                  </a>
                </strong>
              )}
            </header>
            <p className="adv-scrollbars">{note.Description}</p>
          </div>
        </section>
      </div>
    );
  }
}
